<docs>
  Possible displayTypes. Please keep up-to-date. There is a method below!
    Please update thisDisplayTypeShowsClosenessQualifierBar
</docs>

<template>
    <bootstrap class="coupon-card" v-if="isLoaded && !errors">
      <div :class="displayType + '-coupon-wrapper'" v-if="displayType != 'SPOTLIGHT'">
				<div :class="displayType + '-coupon-image'" v-if="orderContext === 'curbside'">
						<a href="javascript:void(0);" @click="openCouponDetailModal(coupon.couponId)"><img alt="Digital Coupons" v-bind:src="coupon.imageUrl" /></a>
				</div>
        <div :class="displayType + '-coupon-image'" v-else>
						<img alt="Digital Coupons" v-bind:src="coupon.imageUrl" />
				</div>
				<div :class="displayType + '-coupon-content'">

					<div :class="displayType + '-coupon-offer'" v-if="orderContext === 'curbside' && coupon.bubbleCallOut">
            <a href="javascript:void(0);" @click="openCouponDetailModal(coupon.couponId)" v-html="coupon.bubbleCallOut"></a>
          </div>
          <div :class="displayType + '-coupon-offer'" v-if="orderContext != 'curbside' && coupon.bubbleCallOut">
						{{coupon.bubbleCallOut}}
					</div>
					<div :class="displayType + '-coupon-description'" v-if="orderContext === 'curbside'">
						<a href="javascript:void(0);" @click="openCouponDetailModal(coupon.couponId)" v-html="coupon.displayName"></a>
					</div>
          <div :class="displayType + '-coupon-description'" v-else v-html="coupon.displayName">
					</div>
					<div :class="displayType + '-coupon-limit'">
							<div :class="displayType + '-coupon-days-left coupon-days-left'" v-if="coupon.daysLeft <= 3"><div class="coupon-days-left-number">{{actualDaysLeft}}</div> {{actualDaysLeft | pluralize('day')}} left</div>
							 Expires {{ coupon.expirationDate | formatDate }}, {{coupon.rewardLimit}}
					</div>

          <div :class="displayType + '-coupon-desktop'">
            <div :class="displayType + '-coupon-actions coupon-actions'">
              <div v-show="coupon.unclipped">
                  <button class="btn btn-xs btn-coupon" @click="clipCoupon(coupon.couponId)"><i class="fa fa-scissors" aria-hidden="true"></i> Clip</button>
              </div>

              <div v-show="!coupon.unclipped">
                  <button class="btn btn-xs btn-coupon btn-coupon-clipped btn-disabled"><i class="fa fa-scissors" aria-hidden="true"></i> Clipped</button>
              </div>
            </div>

            <div v-if="coupon.closenessQualifiers.length && orderContext === 'curbside' && displayType != 'pdp'" :class="displayType + '-closeness-wrapper'">
              <closeness-qualifier
                v-bind:cartItem="item"
                v-bind:cq="cq"
                v-bind:coupon="coupon"
                v-for="(cq, index) in coupon.closenessQualifiers"
                v-bind:key="'cq'+index">
              </closeness-qualifier>

              <social-sharing
                v-bind:coupon="coupon"
                location='CPL'>
              </social-sharing>
            </div>


          </div>

				</div>
			</div>

      <div :class="displayType + '-coupon-mobile'" v-if="displayType != 'SPOTLIGHT'">
        <div :class="displayType + '-coupon-actions coupon-actions'" v-if="displayType != 'pdp'">
            <div v-show="coupon.unclipped">
              <button class="btn btn-xs btn-coupon" @click="clipCoupon(coupon.couponId)"><i class="fa fa-scissors" aria-hidden="true"></i> Clip</button>
          </div>

          <div v-show="!coupon.unclipped">
              <button class="btn btn-xs btn-coupon btn-coupon-clipped btn-disabled"><i class="fa fa-scissors" aria-hidden="true"></i> Clipped</button>
          </div>
        </div>
        <div v-if="coupon.closenessQualifiers.length && orderContext === 'curbside'">
          <closeness-qualifier
            v-bind:cartItem="item"
            v-bind:cq="cq"
            v-bind:coupon="coupon"
            v-for="(cq, index) in coupon.closenessQualifiers"
            v-bind:key="'cq'+index">
          </closeness-qualifier>
        </div>
        <social-sharing
          v-bind:coupon="coupon"
          location='CPL'
          v-if="displayType != 'pdp'">
        </social-sharing>
      </div>


      <div v-if="displayType === 'SPOTLIGHT'">
        <div class="coupon-callout-text">
            <strong v-if="coupon.couponDisplayType === 'F'">Featured Offer </strong>
            <strong v-if="coupon.couponDisplayType === 'T'">Only for You </strong>
            <strong v-if="coupon.couponDisplayType === 'G'">Bundle Offer </strong>
            <span v-if="coupon.daysLeft <= 3"><span class="badge badge-pill badge-light">{{actualDaysLeft}}</span> {{actualDaysLeft | pluralize('day')}} left</span>
        </div>

        <a href="javascript:void(0);" @click="openCouponDetailModal(coupon.couponId)">
          <div class="coupon-item-image">
              <img alt="Digital Coupons" v-bind:src="coupon.imageUrl" class="coupon-carousel-image"/>
              <div v-if="coupon.inStoreOnly" class="promo-flag--in-store-only--short">
                <div class="coupon-flag-text text-left">In Store Only</div>
              </div>
          </div>
          <div class="coupon-description" v-html="coupon.displayName"></div>
          <div class="coupon-offer" v-html="coupon.bubbleCallOut"></div>
        </a>

        <div class="coupon-actions">

          <div v-show="coupon.unclipped">
              <button class="btn btn-full-width btn-coupon coupon-item-action-button" @click="clipCoupon(coupon.couponId)"><i class="fa fa-scissors" aria-hidden="true"></i> Clip</button>
          </div>

          <div v-show="!coupon.unclipped">
              <button class="btn btn-full-width btn-coupon coupon-item-action-button btn-coupon-clipped btn-disabled"><i class="fa fa-scissors" aria-hidden="true"></i> Clipped</button>
          </div>

        </div>
      </div>

		</bootstrap>
</template>

<script>
import moment from 'moment'
import ClosenessQualifier from './ClosenessQualifier'
import SocialSharing from './sharing/SocialSharing'

export default {
  name: 'CouponCard',
  components: {
    'closeness-qualifier': ClosenessQualifier,
    'social-sharing' : SocialSharing
  },
  props: {
    couponId: {
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    position: {
      type: Number
    }
  },
  data () {
    return {
      orderContext: window.heb.data.user.orderContext,
      isLoaded: false,
      errors: false,
      weight: 0,
      coupon: {}
    }
  },
  computed: {
    thisDisplayTypeShowsClosenessQualifierBar(){
      var allDisplayTypes = [
        // 'SPOTLIGHT', // Homepage carousel
        'PDP', // Product Detail Page
        // 'CPL' // Coupon Product Listing, /search/coupon-detail/?q=80002470
      ]
      if(allDisplayTypes.indexOf(this.displayType.toUpperCase()) > -1){
        return true
      }else{
        return false
      }
    },
    howManyMoreProducts () {
      if (this.coupon.buyItems.length > 26) {
        return this.coupon.buyItems.length
      }
    },
    totalCommerceItemCount (){
        return this.$store.state.cart.totalCommerceItemCount
    },
    clippedCouponIds (){
        return this.$store.state.profile.clippedCouponIds
    },
    actualDaysLeft () {
      if (this.coupon.daysLeft === 0) {
        return 1
      }else{
        return this.coupon.daysLeft
      }
    }
  },
  filters: {
    formatDate (date) {
      return date ? moment(String(date)).parseZone().format('MM/DD') : ''
    }
  },
  methods: {
    clipCoupon () {
        if(!window.heb.data.user.isGuest){
            var vm = this
            this.gtmClickCoupon('e_selectCoupon', this.coupon, this.position)
            this.$store.dispatch('cart/CLIP_COUPON', {couponId: this.couponId, callback: vm.getCouponDetails})
        }else{
            window.location = '/my-account/login';
        }
    },
    getCouponDetails: function () {
      var vm = this
      VueStore.$store.dispatch('cart/FETCH_COUPON_DETAILS', {
        id: this.couponId,
        callback: vm.processCouponResponse,
        summary: true})
    },
    processCouponResponse(response){
        this.isLoaded = true
        if(response.errors){
            this.errors = true
            return
        }
        this.coupon = response
    },
    openCouponDetailModal: function(couponId){
      if(typeof couponId === 'undefined') {
        console.log("There is no couponId associated.")
        return
      }
      if(this.$route && this.$route.query.modalId == 'sparkle'){
        // are we in the sparkle modal?
        // If so, when the user closes the modal, they will be sent back to the sparkle modal instead of closing. (anti pattern)
        this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId, closeAction: 'back'})
      }else if(this.$route){
        // not in the sparkle, maybe in a SPA cart item
        this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId, closeAction: 'back'})
      }else{
        // in the non spa app
        this.$store.commit('profile/OPEN_MODAL', {
        id: 'coupon-detail',
        options: {couponId: couponId}
      })
        // this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId})
      }
      this.gtmClickCoupon('e_couponDetails', this.coupon, this.position)
    }
  },
  mounted: function () {
    this.getCouponDetails()
  },
  watch: {
      totalCommerceItemCount (newCount, oldCount){
        // Why are we watching this?
        // to see if we need to update the closeness qualifier
        if(this.thisDisplayTypeShowsClosenessQualifierBar){
          this.getCouponDetails()
        }
      },
      clippedCouponIds (newCount, oldCount) {
        // Why are we watching this?
        // to trigger updates when another component clips a coupon
        if(newCount.indexOf(this.couponId) > -1){
          // The coupon has been cliped from somewhere
          this.getCouponDetails()
        }

      }
  }
}
</script>

<style lang="scss" scoped>
.coupon-carousel-image{
  max-height: 155px;
  height: 100%;
  width: auto;
  margin: 0 auto;
}
</style>

<style lang="scss">
    // This component is standalone, and therefore needs curbside styles
    @import '../styles';

    .CPL-coupon-wrapper {
      display: flex;
      margin: 20px 0 0;
    }
    .CPL-coupon-image {
      flex-shrink:0;
    }
    .CPL-coupon-content {
      margin-left:10px;
    }
    .CPL-coupon-offer {
      color: #dc291e;
      font-weight: 700;
      font-size: 22px;
      a {
        color: #dc291e;
        font-weight: 700;
        font-size: 22px;
        &:hover, &:active {
          color: #DC291E;
        }
      }
    }
    .CPL-coupon-description {
      font-size: 17px;
      font-weight: 700;
      a {
        font-size: 17px;
        font-weight: 700;
      }
    }
    .CPL-coupon-limit {
      font-size: 12px;
      color: #8B8B8B;
      text-transform: lowercase;
      line-height: 1.2;
      margin-top: 1em;
        margin-bottom: 1em;
    }
    .CPL-coupon-actions {
      margin: 0 auto 15px;
      .btn {
        width: 100%;
      }
    }
    .CPL-coupon-mobile {
      margin-bottom:20px;
    }
    .CPL-coupon-desktop {
      display:none;
    }

    .closeness-qualifier {
      margin-top:10px;
    }


    @media screen and (min-width: 768px){
      .CPL-coupon-mobile {
        display:none;
      }
      .CPL-coupon-desktop {
        display:block;
      }
      .CPL-coupon-limit {
        font-size: 0.9rem;
      }
      .CPL-coupon-actions {
        .btn {
          width: 260px;
        }
      }

    }
    @media screen and (min-width: 1024px){
      .CPL-coupon-wrapper {
        margin: 20px 50px;
        max-width:910px;
      }
      .CPL-coupon-image {
        text-align:center;
        flex-grow: 1;
        margin: auto 0;
        img {
          width:auto;
        }
      }
      .CPL-coupon-content {
        text-align:center;
        flex-grow: 1;
        padding: 0 55px;
      }
      .CPL-coupon-offer {
        font-size: 25px;
      }
      .CPL-coupon-description {
        font-size: 20px;
        a {
          font-size: 20px;
        }
      }
      .CPL-closeness-wrapper {
        display:inline-block;
      }
    }

    .promo-flag--in-store-only--short {
      bottom: 0;
      right: unset;
      // Fixes centering on IE
      margin: 0;
    }
</style>
